import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryAddress',
  props: {
    name1: null,
    name2: null,
    street: null,
    postalCode: null,
    city: null,
    country: null,
    phone: null,
    email: null,
    phoneLabel: null,
    emailLabel: null
  },
  setup(__props: any) {



function isBothEmpty(value1: string, value2: string) : boolean {
    return !value1 && !value2;
}

return { __sfc: true,isBothEmpty }
}

})